import { GridColDef } from "@mui/x-data-grid";
import ConfirmActionButton from "../../../components/Fleet/ConfirmActionButton/ConfirmActionButton";

export const trucksTableColumns: GridColDef[] = [
  { field: "unitNumber", headerName: "Unit Number", width: 250 },
  { field: "vin", headerName: "VIN", width: 300 },
  { field: "make", headerName: "Make", width: 300 },
  { field: "model", headerName: "Model", width: 250 },
  { field: "year", headerName: "Year", width: 100 },
  { field: "status", headerName: "Status", width: 150 },
  { field: "transactionType", headerName: "Transaction Type", width: 200 },
  {
    field: "delete",
    headerName: "",
    width: 130,
    renderCell: (params) =>
      params.row.isActive ? (
        <ConfirmActionButton
          id={params.row.id}
          entityType="Truck"
          actionType="delete"
          entityLabel="truck"
          queryKey="trucksTable"
          buttonLabel="Delete"
          buttonColor="error"
        />
      ) : (
        <ConfirmActionButton
          id={params.row.id}
          entityType="Truck"
          actionType="restore"
          entityLabel="truck"
          queryKey="trucksTable"
          buttonLabel="Restore"
          buttonColor="success"
        />
      ),
  },
];
